'use client';

import { ConsentGate } from '@hc-frontend/features-data-consent';

import { config } from '../../../context/config';

function GlobalHealthPixelsInternal() {
  return config.core.appEnvironment === 'prd' ? (
    <>
      <script
        id="bing-pixel-health-global"
        type="text/partytown"
        dangerouslySetInnerHTML={{
          __html:
            '!function(t,e,a,n){var o,r;t[n]=t[n]||[],o=function(){var e={ti:"5280595"};e.q=t[n],t[n]=new UET(e),t[n].push("pageLoad")},(r=e.createElement(a)).src="//bat.bing.com/bat.js",r.defer=1,r.onload=r.onreadystatechange=function(){var e=this.readyState;e&&"loaded"!==e&&"complete"!==e||(o(),r.onload=r.onreadystatechange=null)},(e=e.getElementsByTagName(a)[0]).parentNode.insertBefore(r,e)}(window,document,"script","uetq");',
        }}
      />

      <script
        id="yahoo-pixel-health-global"
        type="text/partytown"
        dangerouslySetInnerHTML={{
          __html:
            '!function(a,e,t,n){a[n]=a[n]||[],a[n].push({projectId:"10000",properties:{pixelId:"10039746"}});var o=e.createElement(t),e=(o.src="https://s.yimg.com/wi/ytc.js",o.defer=!0,o.onload=o.onreadystatechange=function(){var t,e=this.readyState,o=a[n];if(!e||"complete"==e||"loaded"==e)try{t=YAHOO.ywa.I13N.fireBeacon,a[n]=[],a[n].push=function(e){t([e])},t(o)}catch(e){}},e.getElementsByTagName(t)[0]);e.parentNode.insertBefore(o,e)}(window,document,"script","dotq");',
        }}
      />

      <script
        id="outbrain-all"
        type="text/partytown"
        dangerouslySetInnerHTML={{
          __html:
            '!function(t,e){var r,a,o="00f94c0ca2f2e808dad386170a69756a96";t.obApi?t.obApi.marketerId=(a=function(t){return"[object Array]"===Object.prototype.toString.call(t)?t:[t]})(t.obApi.marketerId).concat(a(o)):((r=t.obApi=function(){r.dispatch?r.dispatch.apply(r,arguments):r.queue.push(arguments)}).version="1.1",r.loaded=!0,r.marketerId=o,r.queue=[],(a=e.createElement("script")).async=!0,a.src="//amplify.outbrain.com/cp/obtp.js",a.type="text/javascript",(t=e.getElementsByTagName("script")[0]).parentNode.insertBefore(a,t))}(window,document),obApi("track","PAGE_VIEW");',
        }}
      />
    </>
  ) : null;
}

/**
 * Global health insurance tracking pixels
 * Gated by consent - only loads if user accepts all cookies
 */
export function GlobalHealthPixels() {
  return (
    <ConsentGate>
      <GlobalHealthPixelsInternal />
    </ConsentGate>
  );
}
